import { List, SimpleList } from 'react-admin';

import { useOpsList } from '@pumpkincare/users';

import NoResultsPaper from '../../../../../shared/components/no-results-paper';
import { orderUsersByEmail } from '../../../../../shared/utils/orderUsersByEmail';
import ClaimListActions from '../ClaimListActions';
import ClaimPrimarySession from '../ClaimPrimarySession/ClaimPrimarySession';
import ClaimSecondarySession from '../ClaimSecondarySession';
import ClaimTertiarySession from '../ClaimTertiarySession';

function ClaimsLibrary() {
  const { data: opsData, isLoading } = useOpsList();

  function rowStyle() {
    return {
      backgroundColor: 'white',
      marginTop: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
    };
  }

  function renderClaimListActions() {
    return (
      <ClaimListActions
        title={'Claims Library'}
        showAssignee={true}
        showStatus={true}
        opsList={isLoading && !opsData ? [] : orderUsersByEmail(opsData)}
        filterOnClick={true}
        filterClaimsOn={['created_at']}
      />
    );
  }

  return (
    <List
      sort={{ field: 'created_at', order: 'DESC' }}
      exporter={false}
      actions={renderClaimListActions()}
      empty={
        <>
          {renderClaimListActions()}
          <NoResultsPaper />
        </>
      }
    >
      <SimpleList
        primaryText={record => <ClaimPrimarySession record={record} />}
        secondaryText={record => <ClaimSecondarySession record={record} />}
        tertiaryText={record => <ClaimTertiarySession record={record} />}
        sx={{
          backgroundColor: 'rgb(0, 125, 255, 0.08)',
          '& li': rowStyle(),
        }}
        empty={<NoResultsPaper />}
      />
    </List>
  );
}

export default ClaimsLibrary;
